import React, { useEffect, useState } from 'react';

const ScrollHideComponent = () => {
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        let timeoutId;

        const handleScroll = () => {
        if (window.scrollY === 0) {
            
            timeoutId = setTimeout(() => {
                setIsVisible(true);
                }, 500); 
        } else {
            
            setIsVisible(false);
        }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
        window.removeEventListener('scroll', handleScroll);
        clearTimeout(timeoutId);
        };
    }, []);

    return (
        <>
        {isVisible && <div className={`scrollarea ${isVisible ? 'fade-in' : 'fade-out'}`}>
                        <div className="mouse"></div> 
                        <p className="mousep">Scroll</p>
                    </div>}
        </>
    );
};

export default ScrollHideComponent;